<template>
  <!--page block includes a navigation and a content block -->
<div class="page" ref="page">
  <!--navigation-->
  <nav class="nav nav--offcanvas-1" ref="nav">
    <!--close button-->
    <div class="nav__close" ref="navCloseBtn"></div>
    <!--navigation list-->
    <ul class="nav__list" ref="navList">
      <!--navigation item-->
      <li class="nav__item" v-if="!getUserData">
        <!--navigation link--><a class="nav__link" @click="$router.push('/')"><i class="nav__link-icon material-icons">home</i>{{ $vuetify.lang.t('$vuetify.welcome') }}</a>
      </li>
      <li class="nav__item" v-if="getUserData && getUserData.user.id">
        <!--navigation link--><a class="nav__link" @click="$router.push('/')"><i class="nav__link-icon material-icons">apps</i>
        {{ $vuetify.lang.t('$vuetify.my-applications') }}</a>
      </li>
      <li class="nav__item"  v-if="getUserData && getUserData.user.id">
        <!--navigation link--><a class="nav__link" @click="$router.push('/')"><i class="nav__link-icon material-icons">group</i>
        {{ $vuetify.lang.t('$vuetify.my-organization') }}</a>
      </li>
       <li class="nav__item"  v-if="getUserData && getUserData.user.id">
        <!--navigation link--><a class="nav__link" @click="$router.push('/')"><i class="nav__link-icon material-icons">settings</i>
        {{ $vuetify.lang.t('$vuetify.administration') }}</a>
      </li>
       <li class="nav__item"  v-if="getUserData && getUserData.user.id">
        <!--navigation link--><a class="nav__link" @click="$router.push('/')"><i class="nav__link-icon material-icons">cached</i>
        {{ $vuetify.lang.t('$vuetify.cui-my-app-requests') }}</a>
      </li>
    </ul>
  </nav>
  <!--content part-->
  <div class="page__content page__content--offcanvas-1" ref="pageContent">
    <slot></slot>
    <!--open navigation button-->
    <div class="nav-open-btn" ref="navOpenBtn">
      <div class="nav-open-btn__bar"></div>
      <div class="nav-open-btn__middlebar"></div>
      <div class="nav-open-btn__bar"></div>
    </div>
  </div>
</div>
</template>
<style>
/* common styles !!!YOU DON'T NEED THEM  */
/* page's styles !!!YOU NEED THEM */
html,

.page,
.page__content {
  position: relative;
}
.page {
  min-height: 100vh;
  -ms-perspective: 1500px;
  -webkit-perspective: 1500px;
          perspective: 1500px;
  background-color: rgba(28, 28, 28, 0.5);
}

.page__content {
  min-height: 100vh;
  background-color: #fff;
}

/* navigation styles */
.nav {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 200px;
  padding: 30px;
  box-sizing: border-box;
  background: linear-gradient(to bottom,#00667c,#6a98a0);
  opacity: 0;
  visibility: hidden;
  z-index: 500;
}

/* nav list styles */
.nav__list {
  position: relative;
  padding: 0;
  margin: 45px 0px 0px -11px;
  list-style-type: none;
}

/* nav item styles */
.nav__item:not(:last-child) {
  margin-bottom: 20px;
}

/* nav link styles */
.nav__link {
  -ms-transition-property: all;
  -webkit-transition-property: all;
  transition-property: all;
  -ms-transition-duration: 0.2s;
  -webkit-transition-duration: 0.2s;
          transition-duration: 0.2s;
           -ms-transition-timing-function: linear;
  -webkit-transition-timing-function: linear;
          transition-timing-function: linear;
           -ms-transition-delay: 0s;
  -webkit-transition-delay: 0s;
          transition-delay: 0s;
  display: -webkit-inline-box;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-box-align: center;
          align-items: center;
  color: #fff;
  text-decoration: none;
}
.nav__link:hover {
     color: #6a98a0;
}

/* nav link icon styles */
.nav__link-icon {
  position: relative;
  top: -3px;
  /* !!!use only with material design icons */
  margin-right: 10px;
  color: currentColor;
}

/* close icon styles */
.nav__close {
  position: relative;
    top: 0px;
    right: 10px;
    width: 40px;
    height: 25px;
    cursor: pointer;
  /* close icon elements */
  /* hover effect */
}
.nav__close:before, .nav__close:after {
  -webkit-transition-property: all;
  transition-property: all;
  -webkit-transition-duration: 0.2s;
          transition-duration: 0.2s;
  -webkit-transition-timing-function: linear;
          transition-timing-function: linear;
  -webkit-transition-delay: 0s;
          transition-delay: 0s;
  display: block;
  width: 4px;
  height: 28px;
  border-radius: 10px;
  content: '';
  -webkit-transform-origin: center center;
          transform-origin: center center;
  background-color: #fff;
}
.nav__close:before {
  position: absolute;
  top: 0;
  left: 18px;
  -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
}
.nav__close:after {
  position: absolute;
  top: 0;
  right: 18px;
  -webkit-transform: rotate(45deg);
          transform: rotate(45deg);
}
.nav__close:hover:before, .nav__close:hover:after {
  background-color: #fff;
}

/* nav open btn styles */
.nav-open-btn {
  position: absolute;
  top: 30px;
  left: 30px;
  -webkit-transition-property: all;
  transition-property: all;
   -ms-transition-property: all;
  -webkit-transition-duration: 0.2s;
          transition-duration: 0.2s;
          -ms-transition-duration: 0.2s;
          -ms-transition-timing-function: linear;
  -webkit-transition-timing-function: linear;
          transition-timing-function: linear;
  -webkit-transition-delay: 0s;
  -ms-transition-delay: 0s;
          transition-delay: 0s;
  width: 25px;
  height: 25px;
  overflow: hidden;
  cursor: pointer;
}
.nav-open-btn.js-hidden {
  -webkit-transition-property: all;
    -ms-transition-property: all;
  transition-property: all;
  -webkit-transition-duration: 0s;
          transition-duration: 0s;
          -ms-transition-duration: 0s;
  -webkit-transition-timing-function: linear;
          transition-timing-function: linear;
          -ms-transition-timing-function: linear;
  -webkit-transition-delay: 0s;
   -ms-transition-delay: 0s;
          transition-delay: 0s;
  opacity: 0;
  visibility: hidden;
}

.nav-open-btn__bar {
  width: 100%;
  height: 1px;
  background-color: #fff;
  border-radius: 20px;
}
.nav-open-btn__middlebar {
  width: 100%;
  height: 2px;
  background-color: #fff;
  border-radius: 20px;
   position: absolute;
  top: 10px;
  left: 0;
}
.nav-open-btn__bar:nth-child(1) {
  position: absolute;
  top: 0;
  left: 0;
}
.nav-open-btn__bar:nth-child(2) {
  position: absolute;
  top: 10px;
  left: 0;
}
.nav-open-btn__bar:nth-child(3) {
  position: absolute;
  top: 20px;
  left: 0;
}

/* Demo #1: styles */
.nav--offcanvas-1 {
  -webkit-transition-property: all;
  transition-property: all;
  -webkit-transition-duration: 0.2s;
          transition-duration: 0.2s;
  -webkit-transition-timing-function: linear;
          transition-timing-function: linear;
  -webkit-transition-delay: 0s;
          transition-delay: 0s;
  left: -300px;
  /* opened styles */
}
.nav--offcanvas-1.js-opened {
  -webkit-transition-property: left;
  transition-property: left;
  -webkit-transition-duration: 0.2s;
          transition-duration: 0.2s;
  -webkit-transition-timing-function: linear;
          transition-timing-function: linear;
  -webkit-transition-delay: 0s;
          transition-delay: 0s;
  left: 0;
  opacity: 1;
  visibility: visible;
}

.page__content--offcanvas-1 {
  -webkit-transition-property: all;
  transition-property: all;
  -webkit-transition-duration: 0.2s;
          transition-duration: 0.2s;
  -webkit-transition-timing-function: linear;
          transition-timing-function: linear;
  -webkit-transition-delay: 0s;
          transition-delay: 0s;
  left: 0;
  /* opened styles */
}
.page__content--offcanvas-1.js-opened {
  -webkit-transition-property: all;
  transition-property: all;
  -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
  -webkit-transition-timing-function: linear;
          transition-timing-function: linear;
  -webkit-transition-delay: 0s;
          transition-delay: 0s;
  left: 50px;
}

</style>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    isUserLoggedIn () {
      return this.$store.getters.isAuth
    },
    getUserData () {
      return this.$store.getters.getUserInfo
    }
  },
  mounted () {
    // CODE TO USE ON YOUR WEBSITE - !!! YOU NEED IT

    // hide nav open btn when the nav is open, adding/removing open classes to nav and content
    var navOpenBtn = this.$refs.navOpenBtn
    var navCloseBtn = this.$refs.navCloseBtn
    var nav = this.$refs.nav
    var pageContent = this.$refs.pageContent
    var navList = this.$refs.navList
    // var page = this.$refs.page

    navOpenBtn.classList.add('js-hidden')
    nav.classList.add('js-opened')
    pageContent.classList.add('js-opened')

    // open nav
    navOpenBtn.addEventListener('click', function () {
      navOpenBtn.classList.add('js-hidden')

      nav.classList.add('js-opened')

      pageContent.classList.add('js-opened')
    })

    // close nav
    navCloseBtn.addEventListener('click', function () {
      navOpenBtn.classList.remove('js-hidden')

      nav.classList.remove('js-opened')

      pageContent.classList.remove('js-opened')
    })

    // // closing navigation if click outside it
    // page.addEventListener('click', function (e) {
    //   var evTarget = e.target
    //   if ((evTarget !== nav) && (nav.classList.contains('js-opened')) && (evTarget !== navOpenBtn) && (evTarget.parentNode !== navOpenBtn)) {
    //     navOpenBtn.classList.remove('js-hidden')
    //     nav.classList.remove('js-opened')
    //     pageContent.classList.remove('js-opened')
    //   }
    // })

    // DEMO CODE - !!!YOU DON'T NEED IT
    var demoBtns = document.querySelectorAll('.demo-btn')

    // adding default demo classes
    nav.classList.add('nav--offcanvas-1')
    pageContent.classList.add('page__content--offcanvas-1')

    // change demo on btn click
    demoBtns.forEach(function (el, ind) {
      el.addEventListener('click', function () {
        // add active class to active btn
        demoBtns.forEach(function (el) {
          el.classList.remove('js-active')
        })

        this.classList.add('js-active')

        // add proper classes for effects
        var effClass = ind + 1

        nav.classList.remove('js-opened')

        pageContent.classList.remove('js-opened')

        navCloseBtn.classList.remove('js-opened')

        navList.classList.remove('js-opened')

        navOpenBtn.classList.remove('js-hidden')

        nav.classList.remove(nav.classList[1])

        nav.classList.add('nav--offcanvas-' + effClass)

        pageContent.classList.remove(pageContent.classList[1])

        pageContent.classList.add('page__content--offcanvas-' + effClass)
      })
    })
    window.onpopstate = function (event) {
      navOpenBtn.classList.remove('hide')
    }
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/partials/Menus/Menu.vue